// Mapa con ubicaciones en vivo (Leaflet). Ver CLAUDE.md §7 (FASE 2).
// Usa CircleMarker para no depender de los assets de íconos de Leaflet (rotos con bundlers).
import { CircleMarker, MapContainer, Popup, TileLayer } from 'react-leaflet'
import 'leaflet/dist/leaflet.css'
import type { LiveLocation } from '@/store/locationStore'

interface Props {
  locations: LiveLocation[]
  center?: [number, number]
}

// Centro por defecto: CDMX.
const DEFAULT_CENTER: [number, number] = [19.4326, -99.1332]

export function MapView({ locations, center }: Props) {
  const initial = center ?? (locations[0] ? [locations[0].lat, locations[0].lng] : DEFAULT_CENTER)
  return (
    <MapContainer center={initial} zoom={11} className="h-full w-full rounded-xl" scrollWheelZoom>
      <TileLayer
        attribution="&copy; OpenStreetMap"
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      {locations.map((loc) => (
        <CircleMarker
          key={loc.user_id}
          center={[loc.lat, loc.lng]}
          radius={9}
          pathOptions={{ color: '#0a8aa3', fillColor: '#13b4cf', fillOpacity: 0.9, weight: 2 }}
        >
          <Popup>
            <strong>{loc.name}</strong>
            <br />
            {new Date(loc.timestamp).toLocaleTimeString('es-MX')}
            {loc.accuracy != null && <> · ±{Math.round(loc.accuracy)} m</>}
          </Popup>
        </CircleMarker>
      ))}
    </MapContainer>
  )
}
